export default __webpack_public_path__ + "static/media/bears-hide.dc5c1462.jpeg";